<template>
    <rkm-modal
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        open(item) {

            this.items = [
                {
                    field: 'Data/hora do último envio',
                    value: item.riaDataHoraEnvio,
                },
                {
                    field: 'Número de protocolo da RNDS',
                    value: item.riaIdentificadorRnds,
                },
            ]

            this.$refs.Modal.show()
        },
    },
}
</script>